module.exports = __webpack_public_path__ + "media/images/icons/mail-a4131401250c78d573ab02bfe0fbdd4a.png";